/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Stateofpartner2Inputs */

const de__field_stateofpartner2 = /** @type {(inputs: _Field_Stateofpartner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundesland`)
};

/**

* @param {_Field_Stateofpartner2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_stateofpartner2 = /** @type {((inputs?: _Field_Stateofpartner2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Stateofpartner2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_stateofpartner2(inputs)
});
export { _field_stateofpartner2 as "_field_stateOfPartner" }